module.exports = __webpack_public_path__ + "static/hermes-07e28f94a3b566c0ed30061f8af5c125.jpg";